var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _path10, _path11, _path12, _g4, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _g6, _path19, _path20, _g7, _g8, _path21, _path22, _path23, _path24, _path25, _g9, _path26, _path27, _path28, _g10, _g11, _path29, _path30, _path31, _path32, _path33, _g12, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1096.9 719.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m445.16 754.83h50.998v-46.498h-50.998v46.498z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m614.66 761.82h232.49v-90.977h-232.49v90.977z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.008928,
    x2: 0.68304,
    y1: 1.8489,
    y2: -0.54859
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.93104,
    x2: 0.26436,
    y1: 0.025164,
    y2: 0.61635
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -0.013593,
    x2: 1.2806,
    y1: 1.0017,
    y2: -0.10469
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -0.031226,
    x2: 0.17345,
    y1: 0.97575,
    y2: 0.87325
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.18667,
    x2: 0.77333,
    y1: 0.92425,
    y2: 0.28652
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.006965,
    x2: 0.47883,
    y1: 0.70659,
    y2: -0.26178
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.5,
    x2: 0.5,
    y1: 1.0001,
    y2: -0.000191
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989696",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9e9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -0.84173,
    x2: 1.1974,
    y1: 1.1316,
    y2: 0.026313
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    stopOpacity: 0,
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m301.36 525.6s5-150 57.5-145 85 75 85 75l-142.5 70z",
    fill: "#6e6b6c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m91.356 322.26s-5-59.166 15-64.166 65 35 65 35-3.75 48.333-3.75 48.333l-76.25-19.167z",
    fill: "#5a5758"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m312.61 116.85l27.5-26.25s-91.25-17.5-135 5 103.75-36.25 107.5 21.25z",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m227.19 98.931l-60 137.5s17.5 8.3331 17.5 8.3331l53.333-153.33-10.833 7.5z",
    fill: "#bdbcbc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.4 440.98l53.289-4.5508s6.7914-7.5977 4.9164-33.846c-1.875-26.249-43.123-105-43.123-105s5.7068-6.1584 5.7068-6.1584l-35.88 0.44617s31.966 40.359 15.092 149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.35 533.93c0 86.757-58.95 156.59-131.67 157.08-60.832 0.41626-131.67-70.328-131.67-157.08 0-86.753 60.616-113.33 133.33-113.33 72.717 0 130 26.578 130 113.33z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m495.52 544.76c-1.4575 59.735-3.3337 109.17-66.666 115-41.722 3.8428-98.443-48.395-104.17-112.5-4.1669-46.666 22.494-88.334 80.833-88.334 11.666 0 90.834 51.668 90 85.834z",
    fill: "#e0e0e0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m132.43 364.55c4.1687 41.173-0.76965 75.394-11.028 76.431-10.259 1.0376-21.952-31.498-26.12-72.671-4.1681-41.174 0.77088-75.395 11.028-76.433 10.258-1.0382 21.954 31.499 26.12 72.673z",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m127.47 363.34c3.4527 34.104-0.63782 62.449-9.1351 63.308-8.4973 0.85938-18.183-26.09-21.635-60.194-3.4521-34.104 0.63844-62.449 9.1351-63.309 8.4967-0.85998 18.184 26.091 21.635 60.195z",
    fill: "#c8c7c7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m160.73 94.973s26.875-13.75 46.25-14.375 86.25 0.625 86.25 0.625-121.25 11.875-132.5 13.75z",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m147.01 100.6l86.395-6.25s16.073-9.375 16.073-9.375-111.17 6.25-102.47 15.625z",
    fill: "#666"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 1.25 -337.48 1061.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m381.73-782.43s37.334-5.3335 54-5.3335 39.666-2.667 76.666 2 24 8.667 24 8.667l-34.666-6.667s-25.334-0.33301-33.334-0.33301-36.667 1-43.334 2.6665c-6.6665 1.6665-15.333 6-15.333 6l-2 0.6665-13.667 1.667s-0.99951-5.3335-12.333-9.3335z",
    fill: "url(#s)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 1.25 -337.48 1061.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m510.55-433.11s4.333-20.667 6-25.333c1.666-4.666 6-15 6-15s-0.66699-4.332-0.66699-10.666c-0.89398-46.042 29.87-68.561 61.837-27 30.182 51.218 40.418 87.5 63.666 155.21 1.668 3.666 21.831 6.459 30.497 8.459s52.334 6.334 71.334 7c19 0.66598 42 1.001 79.332-5.333 37.334-6.334 94-21 94-21s110-32.335 120-36.001 21-9.334 24-16 3.334-11.666 3.334-11.666l3.666-9s-3.666 7.333-6.666 8.333 4.3319-8.001 6-10.667c1.666-2.666 6.666-10.666 8.33-15.666 1.67-5 3.34-11.667 3.67-16.667 0.32996-5 1.33-6.333 1.33-6.333s6-15 6.34-18c0.33008-3-0.33997-13-2.6699-17-2.3301-4-6.67-13.333-9-16.333-2.334-3-4.334-5.334-4.334-5.334s-13.998-24.666-22.332-34.999c-8.334-10.334-41.334-44.667-93.334-66.334-52-21.666-70-21-70-21s0 3 2 3 7.332 1.333 2.332 1.667c-5 0.33301-16.998 1.666-34.666 2.333-17.666 0.66699-66.998 6.667-78.332 7.667s-50.666 3-62 4-79.668 6.666-83.002 7c-3.332 0.33301-59.999 3.333-71.332 1.667-11.334-1.667-36.667-5-36.667-5l-2 8s-22.667-5.667-26-8.334c-3.333-2.666-4-3.666-4-3.666s-73.333-25.667-96.333-43c-23-17.334-29.334-25.334-29.334-25.334l6.667 60.667 33.333 106.33 92.667 104.67 6.334 4.666z",
    fill: "#00007f"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m962.18 423.95s-19.002-22.456-39.731-22.456-145.1 3.4549-202.11 48.368c-29.882 23.544-13.819 6.9097 24.184 15.547 38.003 8.6371 215.93-39.731 217.66-41.458z",
    fill: "#999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m452.59 556.96s19.002 15.547 46.64 17.274c27.639 1.7274 60.46-24.184 76.007-6.9097s-5.1822 31.094 29.366 48.368 82.916-34.548 114.01-17.274 120.92-1.7275 120.92-1.7275-143.38 50.095-228.02 44.913c-84.644-5.1823-120.92 17.274-158.92-84.644z",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m776.13 239.34s-76.442-68.744-127.28-106.24c-50.834-37.5-45.001-34.166-53.334-35.833-8.3325-1.6669-27.5-0.83374-27.5-0.83374l5 4.1669 31.668 2.5s169.17 130 164.17 135 7.2754 1.2439 7.2754 1.2439z",
    fill: "#f4f4f4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 1.25 -337.48 1061.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m531.18-765.54s32.554-2.5566 53.22-2.8896c20.666-0.33301 108-0.99951 116.33-0.33301 8.333 0.6665 49.332 1.6665 51.666 1.6665s2.001-1.333-4.666-3.6665-64-11.667-66.667-11.667-5.333-0.6665-5.333-0.6665-26.999-6.0005-34.333-6.3335c-7.334-0.33301-34-1.6665-38.667-1.6665s-6.333 1.9995-9.333 3.6665c-3.0005 1.667-5 0.66699-14.667 0.66699s-64 1.333-64 1.333-35 4-35 4 20.333-0.33301 29 2.3335 15.78 4.2232 22.447 13.556z",
    fill: "#003f7f"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m140.46 81.223s12.547 7.182 17.252 14.363c4.7052 7.182 7.3938 11.752 7.3938 21.545 0 9.7931-3.3606 7.8345-3.3606 7.8345l-23.526-30.033-8.7384-13.71h10.979z",
    fill: "#b4b3b3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m146.36 141.22l-16.875-38.75-0.86372-21.102s7.7387 2.3524 10.239 9.8524c2.5 7.5 25.091 32.784 25.091 32.784l-17.591 17.216z",
    fill: "#808080"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#007fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.356 322.47s-10.625-30.625-7.5-35l3.125-4.375s6.875-22.5 11.25-26.25 8.125-10 8.125-10v-41.875s16.25-36.875 18.125-35 4.8524 7.9774 4.8524 7.9774-9.8524 39.523-2.9774 55.148 15 61.875 36.25 98.125 77.5 113.75 77.5 113.75 38.125 46.25 42.5 51.875c3.0023 3.8599 12.956 16.952 17.5 24.166 2.077 3.2971 1.25 4.5837 1.25 4.5837l-14.583-12.084s-111.25-91.25-137.08-102.92l-2.0837-24.375s-4.375-11.875-6.875-22.5-13.125-58.125-19.375-71.25-9.9548-24.133-16.666-25.625c-5.625-1.25-10 10.001-11.25 19.584-0.34057 2.6135-1.6668 5.8331-0.41686 14.583 0.8148 5.7044-1.6669 21.458-1.6669 21.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.52 155.43s40.833-45.833 64.167-48.333c32.58-3.49 20.833-7.5 46.667-4.167 25.833 3.333 41.667 5.001 45.833 16.667 4.167 11.666 30 145.83 30 145.83s38.333 5 38.333 5l33.334 3.333s58.332 34.167 70 44.167c11.667 10 41.666 31.667 50 44.167l8.333 12.5s8.333 1.666 15.833 2.5c7.5 0.83398 52.5 7.5 97.5 28.334s78.334 44.166 78.334 44.166-55-59.165-85-80.832c-30-21.668-112.5-64.168-128.33-69.168-15.834-5-36.666-11.666-47.5-16.666s-25.834-11.667-25.834-11.667-68.333-7.499-68.333-7.499l-33.333-152.5s-1.113-3.889 1.387-8.055-1.388-0.27798-10.554-6.111-122.5-43.335-180.83 58.332z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m470.86 276.39s100.19-1.7274 169.29-10.365c69.097-8.6371 95.008-8.6371 95.008-8.6371s-105.37 38.003-58.732 76.007c46.64 38.003 183.11 63.915 183.11 63.915s-133.01 38.003-139.92 46.64c-6.9097 8.6372-184.84-150.29-248.75-167.56z",
    fill: "url(#p)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m961.35 396.01s-34.162-78.747-89.995-112.08c-55.834-33.334-94.168-45-94.168-45s69.166 15 97.5 30.833 62.501 35.833 66.668 43.333c4.1663 7.5 17.495 36.248 19.995 82.914z",
    fill: "#007fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m939.25 309.27l-0.781 0.977c22.857 18.7 40.319 40.114 51.953 58.085 5.817 8.986 10.161 17.11 13.008 23.594 2.847 6.485 4.168 11.424 3.984 13.633-0.085999 1.029-0.79401 2.258-2.031 3.594-1.237 1.335-2.974 2.751-5.078 4.179-4.209 2.858-9.795 5.764-15.352 8.36-10.927 5.106-21.555 8.933-21.914 9.062l-3.086-1.562-0.195-0.117-0.273 0.078s-10 3.347-27.5 9.18c-17.427 5.808-75.727 21.657-189.02 33.32-113.31 11.664-140.7 8.307-171.52 4.14-30.756-4.156-91.602-18.32-91.602-18.32h-0.117l-68.32-2.5-0.078 1.25 68.242 2.5s60.807 14.142 91.719 18.32c30.838 4.169 58.442 7.528 171.8-4.14 113.37-11.67 171.72-27.542 189.3-33.399 17.351-5.782 27.097-9.006 27.266-9.062l3.086 1.562 0.273 0.117 0.235-0.117s11.047-3.956 22.226-9.179c5.59-2.612 11.24-5.514 15.547-8.438 2.154-1.462 3.975-2.93 5.313-4.375 1.338-1.444 2.221-2.904 2.343-4.375v-0.039001c0.22095-2.795-1.19-7.639-4.062-14.18-2.882-6.562-7.276-14.714-13.125-23.75-11.699-18.07-29.25-39.599-52.227-58.398z",
    fill: "url(#o)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m230.11 103.72l-46.25 116.88 9.375 5.625 41.042-121.46-4.1669-1.0413z",
    fill: "#6e7479"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#aad4ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.98 220.6l46.25-116.25c-40.298-3.0481-86.11 33.855-103.12 68.75 0 0 28.75 36.25 56.875 47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.23 264.97s-24.375-141.88-35-149.38-13.125-7.5-26.25-8.125-25-1.875-25-1.875l-40.625 113.12 1.25 3.75 73.125 31.875s-16.875-13.75-6.875-25.625c12.941-14.025 26.221-30.921 46.977-28.916 0 0 10.523 60.166 12.398 65.166z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m236.98 103.05c-54.131-2.253-82.338 26.613-112.72 68.375l3.3438 6.25s5.4062-15 24.156-36.25 51.677-33.739 57.094-35.406c5.4169-1.6669 25.406-1.25 25.406-1.25l-41.656 119.56c0.36456-0.63806 0.72467-1.1139 1.0938-1.5312-0.44608 1.6348-0.46875 3.4062-0.46875 3.4062 39.375 18.125 96.488 36.25 96.488 36.25s-75.328-33.741-89.77-40.688c0.48105-1.6569 14.784-50.964 18.062-62.438 3.3337-11.667 18.344-51.25 18.344-51.25s13.344-0.40625 17.094-0.40625 21.229 0.84375 27.062 3.3438c5.8337 2.5 14.173 20.542 14.173 20.542s0.28802-12.361-7.4852-18.885c-4.2938-3.6039-13.344-7.0837-29.594-8.75-6.0938-0.62485-13.315-0.88715-20.625-0.875z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m361.36 271.22s-20.964-86.631-26.666-112.29c-8.3337-37.5-12.912-47.042-10.834-51.458 5-10.625 59.375-7.5 88.125-7.5s161.25 1.25 176.25 1.25 15.847 1.1072 18.75 3.125c88.125 61.25 157.5 127.5 157.5 127.5s-2.5 0.625-13.75 4.375-88.75 11.875-103.75 13.75-285.62 21.25-285.62 21.25z",
    fill: "#aad4ff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -337.48 1061.1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.066 183.43) scale(1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m534.59-577.4s123.48-3.8066 158.99 19.499c47.998 31.498 73.497 70.497 73.497 70.497s-83.997-102-232.49-89.996z",
    fill: "#fff"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -337.48 1061.1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.066 183.43) scale(1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365.1-524.9s16.5-46.498 16.5-46.498l34.498 1.5s-26.999-6-50.998 44.998z",
    fill: "#fff"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m961.98 429.35s41.875-11.25 43.125-22.5-38.75-81.25-52.5-87.5-13.126-7.4976-13.126-7.4976 23.542 32.916 23.126 111.25",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m633.86 590.6l10-0.83252s24.166 16.668 16.666 20c-7.5 3.3325-39.166 6.6675-47.5 2.5-8.3337-4.1675-11.666-10-11.666-10l32.5-11.668z",
    fill: "#a5a3a4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m667.19 555.6s-11.668-15-37.5-17.5-53.332-5.8325-54.166-11.666c-0.83374-5.8337 32.501-0.83252 48.334 0.83374 15.832 1.6663 49.999 3.3325 43.332 28.332z",
    fill: "#b6b5b5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m477.19 505.6s-5-0.83252-5-0.83252 14.166 98.333 22.5 103.33c8.3337 5 2.5012 8.335 19.168 11.668 16.666 3.3325-33.335-55.835-36.668-114.17z",
    fill: "#9a9898"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m956.36 408.72s8.125 19.375 5.625 20.625-53.125 20-89.375 26.875 61.875-30 61.875-30 13.75 9.375 21.875-17.5z",
    fill: "#747273"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#4d5f67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m766.36 603.1s16.665 9.77e-4 35.832-4.1663c19.168-4.1675 108.33-28.335 120.83-34.168 12.5-5.8325 29.168-22.5 35.834-34.166 6.6663-11.666 6.6663-14.166 6.6663-14.166l-189.17 70s-11.668 16.666-11.668 16.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m738.86 549.76s-9.77e-4 8.3337 5.8325 8.3337c5.8337 0 151.67-31.666 188.33-41.666 36.666-10 40-13.334 40-13.334l-25.834-10.834s-208.33 57.5-208.33 57.5z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m742.19 515.6l250-55s5.835 6.6663-0.83252 16.666c-6.6675 10-18.334 25.834-18.334 25.834s-14.166-4.1663-14.166-4.1663 15.832-25.834 15.832-25.834-232.5 42.5-232.5 42.5z",
    fill: "#3b494e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m127.61 177.68s8.75 9.1669 8.75 9.1669-1.6663 25.834 1.6669 39.167c3.3331 13.333 20.833 78.75 37.083 102.5s125.42 179.58 125.42 179.58l-0.41687 12.916s-60.834-77.916-71.667-92.916-53.333-73.332-60.833-86.667c-7.5-13.334-17.916-33.334-22.916-50.001-13.07-43.123-30.156-42.729-17.084-113.75z",
    fill: "#054a8e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m612.61 106.85s156.04 126.46 147.08 127.92c-8.9587 1.4581-46.668 3.3331-46.668 3.3331s-31.666-3.3331-31.666-3.3331-54.166-4.1669-61.666-1.6669-13.334 5-13.334 5 1.665 9.1663 10.832 8.3331c9.1675-0.83313 60-5.8331 60-5.8331s6.6675-1.6669 15.834 0c9.1663 1.6669 20.001 0.83374 10.834 1.6669-9.1675 0.83313-68.335 7.5-74.168 7.5-5.8325 0-170 6.6663-191.67 6.6663-21.666 0-64.166 2.5-74.166-3.3331s-40-139.17-40-139.17 32.502 157.08 37.501 157.29c4.9988 0.20813 50.832 2.7087 100.83-1.4581 50-4.1669 112.5-9.1669 126.67-9.1669 14.166 0 157.5-14.167 162.5-15 5-0.83313 30.834-0.83313 30.834-0.83313s-123.75-104.58-169.58-137.92z",
    fill: "#55595c"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m737.19 515.6s-6.665 2.5012-3.3325 13.334c3.3325 10.832 6.6663 23.332 6.6663 23.332s36.668-8.3325 103.33-23.332c66.666-15 118.33-27.5 118.33-27.5s16.668-35 16.668-35-131.67 30-241.67 49.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m747.19 571.43l218.33-55s-27.499 35-36.666 41.666c-9.1675 6.6663-157.5 48.334-162.5 45-5-3.3337-15.001-2.4988-19.168-31.666z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m450.52 271.43s62.501 24.166 80.834 31.666c18.332 7.5 103.33 51.666 125 70.833 21.666 19.168 46.666 43.335 51.666 49.168 5 5.8325 18.334 26.666 18.334 26.666s54.459-24.014 90.832-30.834c0 0 34.168-9.165 66.668-10.832 32.5-1.6675 68.124-0.62378 68.124-0.62378s-3.1238-10.21-13.958-33.544c-10.834-23.333-38.334-58.333-73.334-84.166s-86.459-47.915-86.459-47.915",
    fill: "#007fff",
    opacity: 0.75,
    stroke: "#918f90"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1026.4 431.85s-1.25 23.75-172.5 56.25-236.25 30-276.25 25",
    stroke: "#a5a3a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.61 513.1s-112.5-25-130-31.25-27.5-10-27.5-10",
    stroke: "#aeacac"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m475.11 615.6l8.75 32.5s62.5 16.25 116.25 18.75 128.75-16.25 207.5-36.25 165-52.5 170-55 10-13.75 15-23.75 7.5-16.25 7.5-16.25-6.25 16.25-76.25 36.25-218.75 66.25-295 63.75-148.75-18.75-153.75-20z",
    fill: "#3d3a3b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m715.52 451.43l28.332 21.666s87.5-6.6663 133.33-19.166c45.834-12.5 79.165-21.668 80.832-25.834 1.6675-4.1663-1.6663-19.375-1.6663-19.375-74.17-7.3174-160.67 5.4348-227.5 40-5.625 3.75-10.415 5.4175-13.332 2.7087z",
    fill: "#231f20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m325.11 99.99s2.4664 5.3125 2.4664 5.3125 4.9335-5.3125 19.733-5.3125h255.3s-270.1-13.281-277.5 0z",
    fill: "#aeacac"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m574.79 519.97s-0.55096-0.056152-1.1719 0.15625c-0.62097 0.2124-1.3622 0.71423-1.9531 1.7188-1.1819 2.0089-1.7597 5.8805-0.078125 13.867 1.6612 7.8898 5.4158 28.316 9.0625 47.07 1.8234 9.3773 3.6175 18.336 5.1172 25.117 0.74988 3.3906 1.4225 6.2709 1.9922 8.3594 0.28485 1.0442 0.54822 1.8893 0.78125 2.5391 0.23303 0.64966 0.34741 1.0505 0.70312 1.4062 1.25 1.2499 3.6513 3.6198 8.3203 5.7422s11.629 4.0343 22.109 4.4531l0.039-1.25c-10.353-0.4137-17.143-2.2915-21.641-4.3359-4.4975-2.0444-6.6796-4.2578-7.9297-5.5078 0.043335 0.043213-0.21552-0.34045-0.42969-0.9375-0.21411-0.59705-0.46228-1.4349-0.74219-2.4609-0.55981-2.0522-1.2447-4.8621-1.9922-8.2422-1.495-6.7604-3.2947-15.744-5.1172-25.117-3.6449-18.746-7.39-39.126-9.0625-47.07-1.6522-7.8472-0.97968-11.475-0.078064-13.008 0.45074-0.76636 0.92035-1.0458 1.2891-1.1719 0.34454-0.11792 0.52252-0.081787 0.54688-0.078125h0.039001c0.06427 0.015015 35.79 8.3203 60.078 8.3203 11.99 0 19.162 2.7145 23.32 5.3516 2.0792 1.3185 3.4113 2.6249 4.2188 3.5938 0.80743 0.96887 1.0547 1.5234 1.0547 1.5234l1.1719-0.5078s-0.3645-0.77344-1.25-1.8359-2.3394-2.4382-4.5312-3.8281c-4.3837-2.7798-11.808-5.5469-23.984-5.5469-24.023 0-59.844-8.3203-59.844-8.3203h-0.039001z",
    fill: "url(#n)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m633.86 604.77v-14.168h-32.5s-6.6663 4.1675 0 11.668c6.6663 7.5 20.834 4.1675 32.5 2.5z",
    fill: "#231f20"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m476.36 455.6s-42.5-100-86.667-115-75.834-0.83313-100.83 60.833",
    stroke: "#abaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.48 341.85l103.12 58.125",
    stroke: "#9c9a9b"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m182.68 217.78l-11.912 34.302-0.039 0.079v0.078003l-4.1797 63.32 1.25 0.078 4.1797-63.281v-0.039001l9.961-29.844-1.1719-0.391 1.9119-4.302z",
    fill: "#808080"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m331.36 268.93l-15.833 59.166-3.3331 33.334s-17.501 70.834-8.3337 112.5",
    fill: "none",
    stroke: "#aeacac",
    strokeWidth: 1.25
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m495.11 376.85s37.5 63.75 42.5 70 16.25 28.75 16.25 28.75 88.75 6.25 113.75 5 76.25-7.5 76.25-7.5-107.5-97.5-248.75-96.25z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m731.36 468.1s-103.75 10-137.5 2.5-65-58.75-58.75-70 15-20 15-20l-55-3.75s55 97.5 61.25 100 95 7.5 113.75 5 76.25-7.5 76.25-7.5-3.75-6.25-15-6.25z",
    fill: "#f0efef"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m961.98 429.35s41.875-16.25 43.125-22.5-15-37.5-15-37.5 20 36.25-28.125 60z",
    fill: "#ccc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m327.19 273.1s-69.798-39.095-52.5-50c17.81-11.228 12.982-18.376 12.982-18.376s-61.882 35.151-12.679 55.913c50.267 21.211 52.197 12.463 52.197 12.463z",
    fill: "#1a1a1a"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m326.99 273.54l-16.675-74.357s-48.102 2.265-43.743 37.45c3.5622 28.757 35.419 34.408 60.419 36.908z",
    fill: "#333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m478.02 508.1l19.166 2.5s14.168 64.166 21.668 77.5 15 31.668 15 31.668-25.834-1.6675-30.834-6.6675-23.334-56.668-25-105z",
    fill: "#231f20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m125.16 355.83c2.8844 24.772 3.8162 57.575-4.9946 58.408-8.8107 0.83313-17.431-29.758-20.316-54.53-2.8844-24.772-0.37456-47.823 8.4362-48.656 8.8107-0.83313 13.99 20.007 16.874 44.779z",
    fill: "#999"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m420.98 479.2s-27.04-16.224-52.727-1.352c-25.688 14.872-33.8 35.827-31.096 71.655 10.668 69.796 92.962 133.96 135.87 63.543l-52.051-133.85z",
    fill: "#ccc"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m381.6 482.43l16.92 29.294s2.7779 13.384 3.5356 11.869c0.7576-1.5151 0.7576-1.7677 0.7576-1.7677l-0.7576-43.437s-2.7779-3.5356-0.25256-3.5356c2.5254 0 7.0711 1.0102 5.8084 2.5254-1.2627 1.5153 0.5051 22.223 0.5051 31.82 0 9.5964 2.5254 16.415 2.5254 16.415l3.0304 1.5151 13.637-36.113s-3.7881-11.364-10.102-13.637c-6.3134-2.2728-19.445-5.0508-22.223-4.2932-2.7779 0.75763 1.7678 4.0406-13.384 9.3439z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m372.76 479.65l1.0102 6.566s-6.3134 2.778-8.0812 5.5558c-1.7678 2.778-2.5254 3.283-2.5254 3.283s-4.0406-1.2627-4.2932-3.283c-0.25253-2.0203-0.75763-4.2932-0.75763-4.2932s-2.0203 2.778 4.7982 8.5863c6.8185 5.8084 27.022 25.759 27.022 25.759l3.0305 3.5355s-18.688-51.77-20.203-45.709z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m354.83 496.32l31.062 37.881s-0.50507 2.0203-2.7779-0.25256c-2.2728-2.2728-38.891-21.213-38.891-21.213l8.8388 2.778s1.0101-6.8186 2.5254-10.354c1.5153-3.5355-0.2525-7.5761-0.7576-8.8388z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m381.09 543.29l-38.133-24.749 6.8185 5.8084s-0.75763 3.7881-1.2627 9.0913c-0.50507 5.3034 0 7.3236 0 7.3236l-6.0609 0.5051 38.638 5.3033s-1.7678 0.25244 0-3.2831z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m380.34 554.91l-36.366-7.071 7.3236 2.5254s-0.25256 4.2931 0.7576 9.8489c1.0101 5.5559 3.283 7.0712 3.283 7.0712l-5.3033 2.7778 28.537-9.3439 2.7779-0.2526s0.25253-1.2627-1.0102-5.5558z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m356.35 574.1l28.032-7.071 2.7779 5.0507-20.203 20.203s-6.3134-8.3337-10.607-18.183z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m392.46 579.4l-20.708 16.668s6.0609 4.0405 7.5761 5.0507 5.0508 6.0609 5.0508 6.0609l10.102-25.759s-1.5152 0.505-2.0203-2.0204z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m403.32 587.23l-14.395 28.537s8.0812 6.566 11.869 7.8287c3.7881 1.2627 3.5355 2.0203 3.5355 2.0203l0.2526-37.628-1.2627-0.7576z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m414.43 589.5s0 12.627-0.25253 18.435c-0.25253 5.8084-3.0305 19.445-3.0305 19.445s4.2932 2.778 10.354 2.778c6.0609 0 8.0812-0.25256 8.0812-0.25256l-15.152-40.406z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m424.53 586.47l5.0508 8.8389 6.566 35.355s13.637-4.5456 15.657-6.0609c2.0203-1.5151-26.769-38.386-27.274-38.133z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m433.12 579.65l23.991 39.901s11.112-8.8389 11.364-10.859c0.25253-2.0203-1.2627-7.071-1.2627-7.071l-34.093-21.971z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m435.39 567.03l19.95 3.0304 8.0812 20.456-28.284-20.708s0.25253 1.7678 0.25253-2.7778z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m433.88 553.9l14.142-4.5457 4.2932 12.122-17.425-3.5355s0.50507-1.7678-1.0102-4.0406z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m440.95 528.39l5.0508 13.89-14.142 4.2931-3.5355-4.7982 12.627-13.384z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m430.09 496.57l-10.354 34.093 4.5457 3.7881 14.647-12.879-8.8388-25.001z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m427.86 549.53c4.5082 12.843-0.66821 26.421-11.562 30.326-10.894 3.9053-23.38-3.3406-27.888-16.184-4.5082-12.843 0.66821-26.421 11.562-30.326 10.894-3.9052 23.379 3.3407 27.888 16.184z",
    stroke: "#000",
    strokeWidth: 1.027
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m426.86 548.03c3.7386 11.275-0.55414 23.194-9.5881 26.623-9.034 3.4284-19.388-2.9326-23.127-14.208-3.7386-11.275 0.55414-23.194 9.5881-26.623 9.034-3.4284 19.388 2.9326 23.127 14.208z",
    fill: "#666",
    strokeWidth: 0.882
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m477.09 455.54c-32.513-89.6-125.81-191.54-189.28-56.783-13.52 36.503 66.247-197.39 189.28 56.783z",
    fill: "#999"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m602.84 325.36l33.46-6.692s-44.932-23.9-50.668-24.856c-5.7359-0.95606-49.712 0.95599-49.712 0.95599l66.92 30.592z",
    fill: "#b3b3b3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m535.92 295.73l68.832 29.636 16.252-4.78-42.064-24.856h-43.02z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m835.14 298.6l21.032-4.78-45.888-30.592-15.296 9.56 40.152 25.812z",
    fill: "#999"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m806.46 266.09l-12.428 7.6479 40.152 22.944 17.208-2.868-44.932-27.724z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m582.14 577.69s-17.274-62.187-5.1822-58.732c12.092 3.4548 82.916 13.819 112.28 15.547 29.366 1.7274-103.65-19.002-107.1 43.186z",
    fill: "url(#q)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m591.72 557.94s-13.87-23.777 1.9814-22.456c15.851 1.3209 38.968 3.3024 38.968 3.3024s-56.14-7.2651-40.949 19.154z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m629.37 538.79s8.5861 3.9629 11.228 7.9257 8.5861 15.191 1.9814 16.512c-6.6047 1.3209-45.572-1.9814-45.572-1.9814s42.27 3.3024 42.27-1.9813c0-5.2838-3.3024-13.21-9.907-20.475z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m589.74 538.79s35.665-5.2837 42.93 3.3024c7.2651 8.5861 11.888 19.814 8.5861 19.814-3.3024 0-58.782 6.6047-51.517-23.116z",
    fill: "#fd5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m104.76 316.47l3.7284 17.208-4.5888-10.898s-1.434-3.1548 0.86039-6.3096z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m102.18 326.23l5.736 17.208-5.736-8.0303s-2.2944-4.0152 0-9.1776z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m109.06 354.33l-7.7436-13.766s-2.2944 12.332 7.7436 13.766z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m109.93 362.07l-6.8832-3.4416s2.5812 3.1548 2.5812 6.0228-0.8604 5.4492-0.8604 5.4492l6.0228-5.1624s-0.28679-0.86041-0.86039-2.868z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m109.93 372.11l-3.7284 2.868 2.0076 7.17 1.7208-10.038z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m112.51 379.28l-4.8756 10.038s1.1472 6.0228 2.868 8.0303c1.7208 2.0076 2.0076-17.495 2.0076-18.068z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m115.09 383.58l-2.5812 17.208s0 4.8756 1.434 5.736c1.434 0.86041 1.434 2.0076 1.434 2.0076l-0.2868-24.952z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m117.38 386.45l-0.2868 23.804s2.5812 1.434 3.1548 0.2868c0.57359-1.1472-2.5812-23.804-2.868-24.091z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m120.54 389.89l2.5812 19.502 0.8604-3.4416-3.4416-16.061z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m113.65 342.57v-24.665l-1.7208-1.7208 1.7208 26.385z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m116.24 346.01l0.2868-21.51s3.7284 6.0228-0.2868 21.51z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m119.1 352.32l1.1472-14.34s2.5812 9.1776 2.5812 11.472-4.0152 6.0228-4.0152 6.0228l0.2868-3.1548z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m120.25 359.21l3.4416-4.0152 1.1472 10.325-4.0152-1.1472s0.2868-2.5812-0.57359-5.1624z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m121.97 370.68l4.0152 3.1548-0.5736 3.1548-3.4416-6.3096z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m120.82 379.57l5.736 13.48-2.0076 2.5812-3.7284-16.061z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m119.67 362.38c0.46153 6.1601-0.76487 11.274-2.7393 11.422-1.9744 0.14792-3.9491-4.7259-4.4106-10.886-0.46153-6.1601 0.76487-11.274 2.7393-11.422 1.9744-0.14792 3.9491 4.7259 4.4106 10.886z",
    stroke: "#000"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m119.73 361.58c0.55474 5.7756-0.36923 10.615-2.0637 10.809-1.6945 0.19424-3.5179-4.3304-4.0726-10.106-0.55474-5.7756 0.36922-10.615 2.0637-10.809 1.6945-0.19424 3.5179 4.3304 4.0726 10.106z",
    fill: "#4d4d4d"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m146.83 249.48s101.92 15.547 114.01 84.644c12.092 69.097 36.276 190.02 36.276 190.02s-129.56-209.02-150.29-274.66z",
    fill: "url(#a)",
    opacity: 0.75
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m345.49 285.75s101.92 72.552 126.1 129.56c24.184 57.005-27.639 72.552-31.094 96.736-3.4548 24.184-44.913-103.65-74.279-114.01-32.579-11.498-44.913 6.9097-51.823 36.276-6.9097 29.366 12.092-89.826 31.094-91.554 19.002-1.7274-17.274 25.911 10.365 25.911s0-67.37-10.365-82.916z",
    fill: "url(#a)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m269.05 83.214s41.026 0.86371 54.846 16.842c6.8735 7.9475 54.414-9.5008 118.33-6.046 63.915 3.4549-150.72-9.069-173.17-10.796z",
    fill: "#00007f"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m126.53 172.61s34.98 35.412 53.118 46.209c17.374 10.342-46.209-20.729-53.118-46.209z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m300.57 206.29l13.819 65.642s-48.368-46.64-13.819-65.642z",
    fill: "url(#r)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.4e31f68585a12af2492ebb479cf429a5.svg";
export { ForwardRef as ReactComponent };